import BasicText from "@/components/BasicText";
import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";

import teamMemberImage from "@/assets/images/team-member-image.svg";
import Image from "@/components/Image";

const Team: React.FC = () => {
  const members = [
    { title: "CEO", name: "TheWizard" },
    { title: "CO-Founder", name: "TheWizard" },
    { title: "Tech Lead", name: "TheWizard" },
  ];

  return (
    <div className="flex flex-col w-full p-20 items-center text-center">
      <Subtitle>// THE BUILDERS</Subtitle>

      <Title className="mt-3">The team behind NODE</Title>

      <BasicText className="mt-6 max-w-[400px]" size="18px" color="faded">
        A diverse group of experts collaborating to shape the future of
        technology.
      </BasicText>

      <div className="flex flex-col mt-20 md:flex-row gap-8">
        {members.map((member) => {
          return (
            <div className="flex flex-col justify-evenly w-full p-4 text-left">
              <Image src={teamMemberImage} alt="team member" />
              <div className="flex flex-col mt-6">
                <Subtitle className="text-[14px]">{member.title}</Subtitle>
                <Title className="text=[24px]">{member.name} </Title>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Team;
